import CallDetails from './components/call-details/CallDetails';

Vue.component('call-details', CallDetails);

if ($('.new-call-modal').length > 0) {

    const app = new Vue({
        el: '.new-call-modal',

        mounted() {
            EventBus.listen('call-details-modal', this.open);
        },

        destroyed() {
            EventBus.stopListening('call-details-modal', this.open);
        },

        methods: {

            open(callId) {
                callId = callId ? callId : null;
                EventBus.fire('call-details-modal-load', callId);
                setTimeout(() => { $(this.$el).modal('show'); }, 0);
            },

            close() {
                $(this.$el).modal('hide');
            },

        },

    });

    $(() => {
        // EventBus.fire('call-details-modal');
        $('.new-call-btn').click((e) => {
            e.preventDefault();
            EventBus.fire('call-details-modal');
        });
    });


}

